<script>
import ContextMenu from './ContextMenu.vue';

export default {
  components: {
    ContextMenu,
  },
  props: {
    stage: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['delete', 'edit'],
};
</script>

<template>
  <div>
    <div class="min-w-[16rem]">
      <div class="stage-node-item flex items-center gap-2">
        <span class="text-heading-3 text-n-slate-12 truncate flex-1">{{
          stage.name
        }}</span>
        <ContextMenu @edit="$emit('edit')" @delete="$emit('delete')" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.stage-node-item {
  @apply rounded-xl shadow-sm outline outline-1 -outline-offset-1 outline-n-weak bg-n-solid-2;
  @apply flex-grow py-3 px-4 truncate overflow-hidden;
}
</style>
